var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "group-message-message-list-container border-top border-gray-500",
    },
    [
      _c("div", { staticClass: "list-title d-flex justify-content-end p-2" }, [
        _c(
          "span",
          {
            staticClass: "badge badge-danger cursor-pointer",
            on: { click: _vm.close },
          },
          [_c("i", { staticClass: "fas fa-times" })]
        ),
      ]),
      _vm._v(" "),
      _c(
        "auto-height",
        { attrs: { margin: 16 } },
        [
          _c("list", {
            staticClass: "px-2 overflow-auto h-100 list",
            attrs: { url: _vm.indexUrl },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (slotProps) {
                  return [
                    _c(
                      "list-item",
                      _vm._b(
                        { key: slotProps.item.id },
                        "list-item",
                        slotProps,
                        false
                      )
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }